import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M14.5 9.25C14.5 8.55965 13.9404 8 13.25 8C12.5596 8 12 8.55965 12 9.25V38.75C12 39.4404 12.5596 40 13.25 40C13.9404 40 14.5 39.4404 14.5 38.75V9.25Z M33.3606 8.31082C33.6277 8.10754 33.9305 8.00036 34.2389 8C34.5472 7.99964 34.8502 8.10675 35.1175 8.3094C35.3848 8.51206 35.6071 8.80322 35.762 9.15477C35.9169 9.50632 35.9989 9.90581 36 10.3124V37.6883C35.9989 38.0949 35.9169 38.4937 35.762 38.8452C35.6071 39.1968 35.3848 39.4886 35.1175 39.6913C34.8502 39.894 34.5472 40.0004 34.2389 40C33.9305 39.9996 33.6277 39.8925 33.3606 39.6892L15.3691 26.0012C15.1045 25.7965 14.8851 25.504 14.7326 25.153C14.5802 24.802 14.5 24.4048 14.5 24.0004C14.5 23.5959 14.5802 23.198 14.7326 22.847C14.8851 22.496 15.1045 22.2042 15.3691 21.9995L33.3606 8.31082ZM17.0273 23.8396L17.0265 23.8412ZM17.0111 23.8915C17.0051 23.919 17 23.956 17 24.0004C17 24.0449 17.0052 24.0818 17.0112 24.1093L33.5 36.6539V11.3461L17.0111 23.8915Z';
var filledPath = 'M34.2389 8C33.9305 8.00036 33.6277 8.10754 33.3606 8.31082L15.3691 21.9995C15.1045 22.2042 14.8851 22.496 14.7326 22.847C14.5802 23.198 14.5 23.5959 14.5 24.0004L14.5 9.25C14.5 8.55965 13.9404 8 13.25 8C12.5596 8 12 8.55965 12 9.25V38.75C12 39.4404 12.5596 40 13.25 40C13.9404 40 14.5 39.4404 14.5 38.75L14.5 24.0004C14.5 24.4048 14.5802 24.802 14.7326 25.153C14.8851 25.504 15.1045 25.7965 15.3691 26.0012L33.3606 39.6892C33.6277 39.8925 33.9305 39.9996 34.2389 40C34.5472 40.0004 34.8502 39.894 35.1175 39.6913C35.3848 39.4886 35.6071 39.1968 35.762 38.8452C35.9169 38.4937 35.9989 38.0949 36 37.6883V10.3124C35.9989 9.90581 35.9169 9.50632 35.762 9.15477C35.6071 8.80322 35.3848 8.51206 35.1175 8.3094C34.8502 8.10675 34.5472 7.99964 34.2389 8Z';
var RewindBeginningIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
RewindBeginningIcon.displayName = 'RewindBeginningIcon';
RewindBeginningIcon.defaultProps = {
  'aria-label': 'Rewind to Beginning'
};
export default RewindBeginningIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/RewindBeginningIcon/index.js
// module id = 1926
// module chunks = 12